import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { makeGetCurrentTeam } from 'selectors/teams';
import { makeGetIsOnTrial, makeGetRemainingTrial } from 'selectors/billing';

import { showModal } from 'actions/modal';

import { useIsBillingOwner } from 'shared-hooks/billing';

import { getToday } from 'utils/date';
import { getPlanById } from 'utils/plan';

const AppUpgradeButton = ({ currentPlanIsFree, isOnTrial, remainingTrial, currentPlan }) => {
    const history = useHistory();
    const { t } = useTranslation('billing');
    const isBillingOwner = useIsBillingOwner();

    const handleUpgradeClick = () => {
        if (currentPlan?.appSumo) {
            history.push({
                pathname: `/settings/team/current/billing`,
                state: {
                    closeUrl: history.location.pathname
                }
            });
            return;
        }

        showModal('SWITCH_PLAN');
    }

    if (!isBillingOwner) {
        return null;
    }

    if (currentPlan?.price?.lifetime || currentPlan?.appSumo || (!currentPlanIsFree && !isOnTrial)) {
        return null;
    }

    return (
        <button className="btn btn-solid btn-small app-bar-btn" onClick={handleUpgradeClick}>
            {
                currentPlanIsFree ? `🚀 ${t('Upgrade your account')}` : t('Days left on trial', {
                    count: remainingTrial
                })
            }
        </button>
    );
}

const makeMapStateToProps = () => {
    const getCurrentTeam = makeGetCurrentTeam();
    const getIsOnTrial = makeGetIsOnTrial();
    const getRemainingTrial = makeGetRemainingTrial();

    return ({ teams }) => {
        const currentTeam = getCurrentTeam(teams);
        const isOnTrial = getIsOnTrial(currentTeam);
        const remainingTrial = isOnTrial && getRemainingTrial(currentTeam, getToday());
        const currentPlanId = currentTeam?.plan;
        const currentPlan = currentPlanId && getPlanById(currentPlanId);
        const currentPlanIsFree = currentPlan?.price?.free;

        return {
            currentPlan,
            currentPlanIsFree,
            isOnTrial,
            remainingTrial
        }
    };
};

export default connect(makeMapStateToProps)(AppUpgradeButton);
